import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dobInput", "guardianSection"]

  connect() {
    this.evaluate()
  }

  evaluate() {
    const dobValue = this.dobInputTarget.value
    if (!dobValue) {
      this.hideGuardian()
      return
    }

    const dob = new Date(dobValue)
    if (isNaN(dob.getTime())) {
      this.hideGuardian()
      return
    }

    const today = new Date()
    let age = today.getFullYear() - dob.getFullYear()
    const monthDiff = today.getMonth() - dob.getMonth()
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--
    }

    if (age < 18) {
      this.showGuardian()
    } else {
      this.hideGuardian()
    }
  }

  showGuardian() {
    this.guardianSectionTarget.classList.remove("hidden")
    this.guardianSectionTarget
      .querySelectorAll('[data-minor-detector-required="true"]')
      .forEach(el => { el.required = true })
  }

  hideGuardian() {
    this.guardianSectionTarget.classList.add("hidden")
    this.guardianSectionTarget
      .querySelectorAll('[data-minor-detector-required="true"]')
      .forEach(el => { el.required = false })
  }
}
